export default {
    objects: 'Объекты',
    sections: 'Секции',
    object: 'Объект',
    section: 'Секция',
    statistics: 'Статистика',
    specifications: 'Спецификации',
};
